/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './study.reducer';

export const Study = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const studyList = useAppSelector(state => state.study.entities);
  const loading = useAppSelector(state => state.study.loading);
  const totalItems = useAppSelector(state => state.study.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="study-heading" data-cy="StudyHeading">
        <Translate contentKey="tinyMedicRestApp.study.home.title">Studies</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.study.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/study/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.study.home.createLabel">Create new Study</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.study.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {studyList && studyList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.study.id">Id</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('studyId')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyId">Study Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyId')} />
                </th>
                <th className="hand" onClick={sort('studyDescription')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyDescription">Study Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyDescription')} />
                </th>
                <th className="hand" onClick={sort('studyInstanceUid')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyInstanceUid">Study Instance Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyInstanceUid')} />
                </th>
                <th className="hand" onClick={sort('accessionNumber')}>
                  <Translate contentKey="tinyMedicRestApp.study.accessionNumber">Accession Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accessionNumber')} />
                </th>
                <th className="hand" onClick={sort('studyDateTime')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyDateTime">Study Date Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyDateTime')} />
                </th>
                <th className="hand" onClick={sort('referringPhysicianName')}>
                  <Translate contentKey="tinyMedicRestApp.study.referringPhysicianName">Referring Physician Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referringPhysicianName')} />
                </th>
                <th className="hand" onClick={sort('additionalPatientHistory')}>
                  <Translate contentKey="tinyMedicRestApp.study.additionalPatientHistory">Additional Patient History</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('additionalPatientHistory')} />
                </th>
                <th className="hand" onClick={sort('admittingDiagnosesDescription')}>
                  <Translate contentKey="tinyMedicRestApp.study.admittingDiagnosesDescription">Admitting Diagnoses Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('admittingDiagnosesDescription')} />
                </th>
                <th className="hand" onClick={sort('studyStatusId')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyStatusId">Study Status Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyStatusId')} />
                </th>
                <th className="hand" onClick={sort('studyPriorityId')}>
                  <Translate contentKey="tinyMedicRestApp.study.studyPriorityId">Study Priority Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('studyPriorityId')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.study.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.study.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.study.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.study.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.study.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('statusCode')}>
                  <Translate contentKey="tinyMedicRestApp.study.statusCode">Status Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('statusCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.study.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.study.rStudy">R Study</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {studyList.map((study, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/study/${study.id}`} color="link" size="sm">
                      {study.id}
                    </Button>
                  </td>
                  <td>{study.studyId}</td>
                  <td>{study.studyDescription}</td>
                  <td>{study.studyInstanceUid}</td>
                  <td>{study.accessionNumber}</td>
                  <td>{study.studyDateTime ? <TextFormat type="date" value={study.studyDateTime} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{study.referringPhysicianName}</td>
                  <td>{study.additionalPatientHistory}</td>
                  <td>{study.admittingDiagnosesDescription}</td>
                  <td>{study.studyStatusId}</td>
                  <td>{study.studyPriorityId}</td>
                  <td>{study.microSec}</td>
                  <td>{study.timestampentry}</td>
                  <td>{study.lastupdated}</td>
                  <td>{study.cursor}</td>
                  <td>{study.active ? 'true' : 'false'}</td>
                  <td>{study.statusCode}</td>
                  <td>{study.patient ? <Link to={`/gluco-user/${study.patient.id}`}>{study.patient.id}</Link> : ''}</td>
                  <td>{study.rStudy ? <Link to={`/radiology-study/${study.rStudy.id}`}>{study.rStudy.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/study/${study.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/study/${study.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/study/${study.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.study.home.notFound">No Studies found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={studyList && studyList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Study;
